import { ReminderEntityTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import { PortfolioRemindersSectionContent } from "web_myplann/Reminders/Components/PortfolioRemindersSectionContent";
import { PropertyRemindersSectionContent } from "web_myplann/Reminders/Components/PropertyRemindersSectionContent";
import type {
	ReminderEntity,
	RemindersSectionVariant,
} from "web_myplann/Reminders/Types/ReminderTypes";

type Props = {
	entity: ReminderEntity;
	variant?: RemindersSectionVariant;
};

export const RemindersSectionContent = ({ entity, variant }: Props) =>
	entity.type === ReminderEntityTypeEnum.Portfolio ? (
		<PortfolioRemindersSectionContent entity={entity} variant={variant} />
	) : (
		<PropertyRemindersSectionContent entity={entity} variant={variant} />
	);
